import { useTranslations } from "next-intl";
import { EmailAccountForm } from "@/components/email-account-form";
import { Heading, Text } from "@/components/ui";
import { platformFetch } from "@/services/http/platform-fetch";

/**
 * MT-1 INFRA-024 S2 (FR-50, AC-104): the platform admin saves, tests and removes one school's own
 * email account — the same form as the school admin's page, against the platform route for that
 * school. The test email goes to the platform admin's own address.
 */
export function SchoolEmailAccountCard({
  tenantId,
  schoolName,
}: {
  tenantId: string;
  schoolName?: string;
}) {
  const t = useTranslations("platform.schoolEmail");
  return (
    <section className="mt-6 space-y-4" data-testid="school-email-account-card">
      <header className="space-y-1">
        <Heading as="h2" level="section">
          {t("title")}
        </Heading>
        <Text tone="muted">{t("intro")}</Text>
      </header>
      <EmailAccountForm
        endpoint={`/platform/admin/tenants/${tenantId}/email-settings`}
        fetcher={platformFetch}
        schoolName={schoolName}
      />
    </section>
  );
}
